import React, { useState } from 'react';
import { formatTimeRange } from '../utils/timeHelpers';
import { EVENT_VARIANTS, CALENDAR_CONSTANTS } from '../utils/constants';

const CalendarEvent = ({
                         event,
                         variant = EVENT_VARIANTS.FREE,
                         position,
                         overlap,
                         selected = false,
                         selectable = false,
                         children,
                         onClick,
                         onSelect,
                         className = '',
                       }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();

    if (selectable && onSelect) {
      onSelect(event);
    } else if (onClick) {
      onClick(event);
    }
  };

  const style = {
    top: position?.top ?? 0,
    height: Math.max(position?.height ?? CALENDAR_CONSTANTS.HOUR_HEIGHT, 20),
    left: overlap?.left ?? '4px',
    width: overlap?.width ? `calc(${overlap.width} - 8px)` : 'calc(100% - 8px)',
    right: overlap?.width ? 'auto' : '4px',
  };

  const isCompact = style.height < 40;
  const timeRange = event.startTime && event.endTime
      ? formatTimeRange(event.startTime, event.endTime)
      : null;

  const variantClass = `calendar-event--${variant}`;

  const hasNotes = !!(event.additionalInfo?.additionalInfo || event.notes);

  const defaultContent = (
      <>
        <div className="calendar-event__title">
          {event.displayTitle || event.title || event.dogDTO?.name || 'Wydarzenie'}
          {hasNotes && (
              <span className="calendar-event__note-icon" title={event.additionalInfo?.additionalInfo || event.notes}>
                {' '}📝
              </span>
          )}
        </div>
        {!isCompact && timeRange && (
            <div className="calendar-event__time">{timeRange}</div>
        )}
      </>
  );

  return (
      <div
          className={`
        calendar-event
        ${variantClass}
        ${selected ? 'calendar-event--selected' : ''}
        ${isCompact ? 'calendar-event--compact' : ''}
        ${selectable ? 'calendar-event--selectable' : ''}
        ${className}
      `}
          style={style}
          onClick={handleClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          role={selectable ? 'button' : undefined}
          tabIndex={selectable ? 0 : undefined}
          onKeyDown={(e) => {
            if (selectable && (e.key === 'Enter' || e.key === ' ')) {
              e.preventDefault();
              handleClick(e);
            }
          }}
      >
        {children || defaultContent}

        {selected && !children && (
            <div className="calendar-event__selected-indicator">✓</div>
        )}

        {event.badge && (
            <div className="calendar-event__badge">{event.badge}</div>
        )}
      </div>
  );
};

export default CalendarEvent;